<div>
  <pos-app-spinner *ngIf="loadingDetailView$ | async"></pos-app-spinner>
  <app-lib-user-email-view
    *ngIf="productInfoBulletinEmailList.length > 0"
    [userEmailList]="productInfoBulletinEmailList"
    (selectedEmail)="showProductInfoBulletinEmailDetail($event)"
    (updatedUserEmailList)="updateProductInfoBulletinEmailList($event)"
    [userSeletedEmailDetails]="productInfoBulletinEmail"
    [title]="title"
    [loading]="loading$ | async"
    [securityFunctions]="securityFunctions$ | async"
    [isInternalUser]="!isExternalUser && !isProgrammeUser"
  ></app-lib-user-email-view>
</div>
